export default __webpack_public_path__ + "static/photo13usluge-6d426d3f0398e3972c8c0c84a786ff6e.png";